import { AppHeader } from './AppHeader';
import { AppFooter } from './AppFooter';

interface AppLayoutProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export function AppLayout({ children, actions }: AppLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <AppHeader actions={actions} />
      <main className="flex-1">
        {children}
      </main>
      <AppFooter />
    </div>
  );
}
